<app-header></app-header>
<div class="content_wrapper">
    <div class="panel-analysis-view">
        <div class="an-top">
            <div class="summary-mentions">
                <div class="spinner-border"></div>
                <ul class="nav nav-tabs" id="myTab" role="tablist">
                    <li class="nav-item" role="presentation">
                        <a class="nav-link active" data-toggle="tab" id="popular-tab" href="#popular" role="tab">The most popular mentions</a>
                    </li>
                    <li class="nav-item" role="presentation">
                        <a class="nav-link" data-toggle="tab" id="mention-tab"  href="#mention" role="tab">Mentions from the most popular public profiles</a>
                    </li>
                </ul>
            </div>
            <div class="bt-top">
                <button (click)="tag_form()" type="button" class="submit-mention btn">Filter Mentions</button>
                <div class="popover-wrapper">
                    <input type="text"
                           ngxDaterangepickerMd
                           [(ngModel)]="selected"
                           [alwaysShowCalendars]="alwaysShowCalendars"
                           [ranges]="ranges"
                           [showClearButton]="true"
                           [showCancel]="true"
                           [linkedCalendars]="true"
                           [locale]="{applyLabel: 'Apply'}"
                           (datesUpdated)="datesUpdated($event)"
                           [keepCalendarOpeningWithRange]="keepCalendarOpeningWithRange"
                           [showRangeLabelOnInput]="showRangeLabelOnInput"
                           class="form-control"/>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-7 col-md-12 col-sm-12">
                <div class="summary-mentions analysis">
                    <div class="spinner-border popular" [style.display]="popularLoading ? 'block' : 'none'"></div>
                    <div class="tab-content" id="myTabContent">
                        <div class="tab-pane fade show active" id="popular" role="tabpanel" aria-labelledby="popular-tab">
                            <div class="pop-content pub-content">
                                <div class="pre-loader">
                                    <ul>
                                        <li *ngFor="let mention of popular_mentions | paginate: { itemsPerPage: page_length, currentPage: p, totalItems: total, id: 'popular_page_list' }; let i = index" [style.display]="can_show_mention(mention.id, mention.profile_id)">
                                            <div class="pop-an-sec meta_ana">
                                                <div class="header">
                                                    <div class="mention-header">
                                                        <div class="img-wrap">
                                                            <img src="{{get_social_icon(mention.mchannel)}}"><span>{{p == 0 ? i+1 : ((p * page_length) - page_length)+(i+1)}}</span>
                                                        </div>
                                                        <div class="content-mention">
                                                            <div class="mention_meta">
                                                                <span class="mention_meta_title">{{mention.name}}</span>
                                                            </div>
                                                            <div class="mention_meta">
                                                                <p>{{mention.description | slice:0:500}}..</p>
                                                            </div>
                                                            <div class="mention-footer">
                                                                <div class="le-foot">
                                                                    <a *ngIf="mention.profile_type_name == 'reddit'" href="{{mention.link}}" target="_blank">www.reddit.com</a>
                                                                    <a *ngIf="mention.profile_type_name != 'reddit'" href="{{mention.link}}" target="_blank">{{mention.link.split("/")[2]}}</a>
                                                                    <span class="mention_date">{{change_date_format(mention.pub_datetime, 'YYYY-MM-DD hh:mm a')}}</span>
                                                                </div>
                                                                <div class="rig-foot">
                                                                    <div>
                                                                        <i title="Engagement" class="fa fa-star"></i> {{mention.mEngagement}}
                                                                        <i title="Posts" class="fa fa-mail-reply"></i> {{mention.statuses_count ? mention.statuses_count : 0}}
                                                                        <i title="Followers" class="fa fa-retweet"></i>  {{mention.followers_count ? mention.followers_count : 0}}</div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div *ngIf="total == 0" class="mention-card">
                                There are no results for your search.
                            </div>
                            <div *ngIf="total != 0" class="mention-card">
                                <div class="paginate_sec_bottom">
                                    <pagination-controls id="popular_page_list" (pageChange)="pageChanged($event)" responsive="true"></pagination-controls>
                                </div>
                            </div>
                        </div>

                        <!---latest-tab--->

                        <div class="tab-pane fade" id="mention" role="tabpanel" aria-labelledby="mention-tab">
                            <div class="latest-content pub-content">
                                <div class="pre-loader">
                                    <ul>
                                        <li *ngFor="let mention of profile_mentions | paginate: { itemsPerPage: profile_page_length, currentPage: profile_p, totalItems: total, id: 'profile_page_list' }; let i = index" [style.display]="can_show_mention(mention.id, mention.profile_id)">
                                            <div class="pop-an-sec meta_ana">
                                                <div class="header">
                                                    <div class="mention-header">
                                                        <div class="img-wrap">
                                                            <img src="{{get_social_icon(mention.mchannel)}}"><span>{{profile_p == 0 ? i+1 : ((profile_p * page_length) - page_length)+(i+1)}}</span>
                                                        </div>
                                                        <div class="content-mention">
                                                            <div class="mention_meta">
                                                                <span class="mention_meta_title">{{mention.name}}</span>
                                                            </div>
                                                            <div class="mention_meta">
                                                                <p>{{mention.description | slice:0:500}}..</p>
                                                            </div>
                                                            <div class="mention-footer">
                                                                <div class="le-foot">
                                                                    <a href="{{mention.link}}" target="_blank">{{mention.link.split("/")[2]}}</a>
                                                                    <span class="mention_date">{{change_date_format(mention.pub_datetime, 'YYYY-MM-DD hh:mm a')}}</span>
                                                                </div>
                                                                <div class="le-foot ml-4">
                                                                    <div class="influence-score"><span style="width:100%"></span></div>
                                                                </div>
                                                                <div class="rig-foot">
                                                                    <div *ngIf="mention.total_count" class="infl_ana">Mentions<br><strong>{{mention.total_count}}</strong></div>
                                                                    <div *ngIf="mention.followers_count" class="infl_ana">Followers<br><strong>{{mention.followers_count}}</strong></div>
                                                                    <div *ngIf="mention.mRank" class="infl_ana">Rank<br><strong>#{{mention.mRank}}</strong></div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div *ngIf="total_profiles == 0" class="mention-card">
                                There are no results for your search.
                            </div>
                            <div *ngIf="total_profiles != 0" class="mention-card">
                                <div class="paginate_sec_bottom">
                                    <pagination-controls id="profile_page_list" (pageChange)="profilePageChanged($event)" responsive="true"></pagination-controls>
                                </div>
                            </div>
                        </div>
                    </div>


                </div>
            </div>
            <div class="col-lg-5 col-md-12 col-sm-12">
                <div class="analysis-box">
                    <div class="analysis-stats">
                        <div class="analysis-stats-section">
                            <i class="fa fa-bar-chart-o"></i>
                            <a class="filter_icon help_qtip tooltip_h">?</a>
                            <span class="tool-ct">Total number of found mentions/threads</span>
                            <div class="analysis-stats-result" [innerHtml]="summary.all"></div>
                            <div class="analysis-stats-title">Mentions</div>
                        </div>
                        <div class="analysis-stats-section">
                            <i class="fa fa-users"></i>
                            <a class="filter_icon help_qtip tooltip_h">?</a>
                            <span class="tool-ct">The number of mentions / threads found on social media platforms</span>
                            <div class="analysis-stats-result" [innerHtml]="summary.sm"></div>
                            <div class="analysis-stats-title">Social media mentions</div>
                        </div>
                        <div class="analysis-stats-section">
                            <i class="fa fa-sign-out"></i>
                            <a class="filter_icon help_qtip tooltip_h">?</a>
                            <span class="tool-ct">The number of mentions / threads found outside social media platforms (e.g. on forums, news websites, etc).</span>
                            <div class="analysis-stats-result" [innerHtml]="summary.nsm"></div>
                            <div class="analysis-stats-title">Non-social Mentions</div>
                        </div>
                        <div class="analysis-stats-section">
                            <i class="fa fa-exchange"></i>
                            <a class="filter_icon help_qtip tooltip_h">?</a>
                            <span class="tool-ct">Total number of interactions generated with collected mentions / threads in social media </span>
                            <div class="analysis-stats-result" [innerHtml]="summary.interactions"></div>
                            <div class="analysis-stats-title">Neutral Mentions</div>
                        </div>
                        <div class="analysis-stats-section">
                            <i class="fa fa-thumbs-o-up"></i>
                            <a class="filter_icon help_qtip tooltip_h">?</a>
                            <span class="tool-ct">The number mentions / threads with potentially negative sentiment. </span>
                            <div class="analysis-stats-result" [innerHtml]="summary.positive"><sup>(58.4%)</sup></div>
                            <div class="analysis-stats-title">Positive mentions</div>
                        </div>
                        <div class="analysis-stats-section">
                            <i class="fa fa-thumbs-o-down"></i>
                            <a class="filter_icon help_qtip tooltip_h">?</a>
                            <span class="tool-ct">The number mentions / threads with potentially negative sentiment. </span>
                            <div class="analysis-stats-result" [innerHtml]="summary.negative"></div>
                            <div class="analysis-stats-title">Negative mentions</div>
                        </div>
                    </div>
                </div>
				
				<!--mentions by category--->
				                <div class="panel-filter">
                    <div class="filter-header">
                        <div class="summary-title">
                            <h2 class="">Mentions by category</h2>
                        </div>
                    </div>
                    <div class="panel_filter_options mention-fit row">
                        <div class="col-lg-12 col-md-12 col-sm-12">
                            <div class="categories_switch switch-prog">
                                <a *ngIf="total_per_sm.twitter != 'denied'" class="">
                                    <div class="results_type"><i class="fa fa-twitter"></i><p>Twitter</p><h5 [innerHtml]="total_per_sm.twitter"></h5>
                                        <div class="progress">
                                            <div class="progress-bar" role="progressbar" style="width: {{pie_percentage.twitter}}%" aria-valuenow="pie_percentage.twitter" aria-valuemin="0" aria-valuemax="100"></div>
                                        </div>
                                    </div>
                                </a>
                                <a *ngIf="total_per_sm.instagram != 'denied'" class="">
                                    <div class="results_type"><i class="fa fa-instagram"></i><p>Instagram</p><h5 [innerHtml]="total_per_sm.instagram"></h5>
                                        <div class="progress">
                                            <div class="progress-bar" role="progressbar" style="width: {{pie_percentage.instagram}}%" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"></div>
                                        </div>
                                    </div>
                                </a>
                                <a *ngIf="total_per_sm.facebook != 'denied'" class="">
                                    <div class="results_type"><i class="fa fa-facebook"></i><p>Facebook</p><h5 [innerHtml]="total_per_sm.facebook"></h5><div class="progress">
                                            <div class="progress-bar" role="progressbar" style="width: {{pie_percentage.facebook}}%" aria-valuenow="pie_percentage.facebook" aria-valuemin="0" aria-valuemax="100"></div>
                                        </div>        
                                    </div>
                                </a>
                                <a *ngIf="total_per_sm.youtube != 'denied'" class="">
                                    <div class="results_type"><i class="fa fa-play"></i><p>Youtube</p><h5 [innerHtml]="total_per_sm.youtube"></h5><div class="progress">
                                            <div class="progress-bar" role="progressbar" style="width: {{pie_percentage.youtube}}%" aria-valuenow="pie_percentage.youtube" aria-valuemin="0" aria-valuemax="100"></div>
                                        </div>
                                    </div>
                                </a>
                                <a *ngIf="total_per_sm.reviews != 'denied'" class="">
                                    <div class="results_type"><i class="fa fa-comment"></i><p>Reviews</p><h5 [innerHtml]="total_per_sm.reviews"></h5>
                                        <div class="progress">
                                            <div class="progress-bar" role="progressbar" style="width: {{pie_percentage.reviews}}%" aria-valuenow="pie_percentage.reviews" aria-valuemin="0" aria-valuemax="100"></div>
                                        </div>
                                    </div>
                                </a>
                                <a *ngIf="total_per_sm.web != 'denied'" class="">
                                    <div class="results_type"><i class="fa fa-share-alt"></i><p>Web</p><h5 [innerHtml]="total_per_sm.web"></h5>
                                        <div class="progress">
                                            <div class="progress-bar" role="progressbar" style="width: {{pie_percentage.web}}%" aria-valuenow="pie_percentage.web" aria-valuemin="0" aria-valuemax="100"></div>
                                        </div>
                                    </div>
                                </a>
<!--                                <a *ngIf="total_per_sm.others != 'denied'" class="">
                                    <div class="results_type"><i class="fa fa-rss"></i><p>Others</p><h5 [innerHtml]="total_per_sm.others"></h5>
                                        <div class="progress">
                                            <div class="progress-bar" role="progressbar" style="width: {{pie_percentage.others}}%" aria-valuenow="pie_percentage.others" aria-valuemin="0" aria-valuemax="100"></div>
                                        </div>
                                    </div>
                                </a>-->
                                <a *ngIf="total_per_sm.others != 'denied'" class="">
                                    <div class="results_type"><i class="fa fa-linkedin"></i><p>Linkedin</p><h5 [innerHtml]="total_per_sm.linkedin"></h5>
                                        <div class="progress">
                                            <div class="progress-bar" role="progressbar" style="width: {{pie_percentage.linkedin}}%" aria-valuenow="pie_percentage.linkedin" aria-valuemin="0" aria-valuemax="100"></div>
                                        </div>
                                    </div>
                                </a>
                                <a *ngIf="total_per_sm.others != 'denied'" class="">
                                    <div class="results_type"><i class="fa fa-object-group"></i><p>Others</p><h5 [innerHtml]="total_per_sm.reddit"></h5>
                                        <div class="progress">
                                            <div class="progress-bar" role="progressbar" style="width: {{pie_percentage.reddit}}%" aria-valuenow="pie_percentage.reddit" aria-valuemin="0" aria-valuemax="100"></div>
                                        </div>
                                    </div>
                                </a>
                            </div>
                        </div>
                        <div class="col-lg-12 col-md-12 col-sm-12 mt-4">
                            <canvas baseChart 
                                    [data]="doughnutChartData"
                                    [labels]="doughnutChartLabels"
                                    [colors]="doughnutChartColors"
                                    [legend]="doughnutChartLegend"
                                    [options]="doughnutChartOptions"
                                    [chartType]="doughnutChartType">
                            </canvas>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-12 col-md-12 col-sm-12">

            </div> 
        </div>
    </div>
</div>
<div id="tag_form_model" class="tag_form_model" *ngIf="show_tag_form">
    <!--<form [formGroup]="tag_form" (ngSubmit)="save_tag(tag_form.value)" id="tag_form">-->
    <div class="modal-dialog modal-sm add_new_form ">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title">Filter Data</h4>
            </div>
            <!-- Modal body -->
            <div class="modal-body">
                <div class="form-group">
                    <label for="projectname">Filter by text</label>
                    <div class="fil-data">
                        <input value="{{text_search}}" id="search_text" class="form-control">
                        <button (click)="text_filter()" type="button" class="btn btn-success"><i class="fa fa-search"></i></button>
                    </div>
                </div>
                <div class="form-group">
                    <label for="projectname">Sentiment Filter</label>
                    <div class="panel_filter_options mention-fit">
                        <ngx-slider [(value)]="sentimant_filter_value" [options]="sentimant_filter_options" (valueChange)="senitment_filter_event($event)"></ngx-slider>
                    </div>
                </div>
                <div class="form-group">
                    <label for="projectname">Language</label>
                    <div class="panel_filter_options mention-fit">
                        <select (change)="language_filter()" id="language_filter" class="form-control">
                            <option [selected]="language == 'any'" value="any">Any Language</option>
                            <option [selected]="language == 'en'" value="en">English</option>
                            <option [selected]="language == 'ar'" value="ar">Arabic</option>
                            <option [selected]="language == 'hr'" value="hr">Croatian</option>
                            <option [selected]="language == 'cs'" value="cs">Czech</option>
                            <option [selected]="language == 'da'" value="da">Danish</option>
                            <option [selected]="language == 'nl'" value="nl">Dutch</option>
                            <option [selected]="language == 'fi'" value="fi">Finnish</option>
                            <option [selected]="language == 'fr'" value="fr">French</option>
                            <option [selected]="language == 'de'" value="de">German</option>
                            <option [selected]="language == 'hu'" value="hu">Hungarian</option>
                            <option [selected]="language == 'id'" value="id">Indonesian</option>
                            <option [selected]="language == 'it'" value="it">Italian</option>
                            <option [selected]="language == 'ko'" value="ko">Korean</option>
                            <option [selected]="language == 'no'" value="no">Norwegian</option>
                            <option [selected]="language == 'pl'" value="pl">Polish</option>
                            <option [selected]="language == 'pt'" value="pt">Portuguese</option>
                            <option [selected]="language == 'ro'" value="ro">Romanian</option>
                            <option [selected]="language == 'ru'" value="ru">Russian</option>
                            <option [selected]="language == 'sk'" value="sk">Slovak</option>
                            <option [selected]="language == 'es'" value="es">Spanish</option>
                            <option [selected]="language == 'sv'" value="sv">Swedish</option>
                            <option [selected]="language == 'th'" value="th">Thai</option>
                            <option [selected]="language == 'tr'" value="tr">Turkish</option>
                            <option [selected]="language == 'vi'" value="vi">Vietnamese</option>
                        </select>
                    </div>
                </div>
                <div class="form-group">
                    <label for="projectname">Country</label>
                    <div class="panel_filter_options mention-fit">
                        <select class="form-control" (change)="filter_by_country($event)" [(ngModel)]="country">
                            <option [selected]="country.cca2 == ''" class="opt_one" value="">All</option>
                            <option [selected]="country.cca2 == country" class="opt_one" *ngFor="let country of countries" value="{{country.cca2}}">{{country.name.common}}</option>
                        </select>
                    </div>
                </div>
                <div class="form-group">
                    <label for="projectname">Channels</label>
                    <div class="panel_filter_options mention-fit">
                        <div class="categories_switch">
                            <div class="modal-cat">
                                <a class="">
                                    <div class="results_type"><i class="fa fa-globe"></i><p>All</p>
                                        <input class="hidden" type="checkbox" value="all" [checked]="checked_sm.all" (click)="sm_checkbox_event($event)">
                                    </div>
                                </a>
                                <a *ngIf="total_per_sm.twitter != 'denied'" class="">
                                    <div class="results_type"><i class="fa fa-twitter"></i><p>Twitter</p><input type="checkbox" value="twitter" [checked]="checked_sm.twitter" (click)="sm_checkbox_event($event)"></div>
                                </a>
                                <a *ngIf="total_per_sm.instagram != 'denied'" class="">
                                    <div class="results_type"><i class="fa fa-instagram"></i><p>Instagram</p><input type="checkbox" value="instagram" [checked]="checked_sm.instagram" (click)="sm_checkbox_event($event)"></div>
                                </a>
                            </div>
                            <div class="modal-cat">
                                <a *ngIf="total_per_sm.facebook != 'denied'" class="">
                                    <div class="results_type"><i class="fa fa-facebook"></i><p>Facebook</p><input type="checkbox" value="facebook" [checked]="checked_sm.facebook" (click)="sm_checkbox_event($event)"></div>
                                </a>
                                <a *ngIf="total_per_sm.youtube != 'denied'" class="">
                                    <div class="results_type"><i class="fa fa-play"></i><p>YouTube</p><input type="checkbox" value="youtube" [checked]="checked_sm.youtube" (click)="sm_checkbox_event($event)"></div>
                                </a>
                                <a *ngIf="total_per_sm.reviews != 'denied'" class="">
                                    <div class="results_type"><i class="fa fa-comment"></i><p>Reviews</p><input type="checkbox" value="reviews" [checked]="checked_sm.reviews" (click)="sm_checkbox_event($event)"></div>
                                </a>
                            </div>
                            <div class="modal-cat">
                                <a *ngIf="total_per_sm.web != 'denied'" class="">
                                    <div class="results_type"><i class="fa fa-share-alt"></i><p>Web</p><input type="checkbox" value="web" [checked]="checked_sm.web" (click)="sm_checkbox_event($event)"></div>
                                </a>
                                <a *ngIf="total_per_sm.others != 'denied'" class="">
                                    <div class="results_type"><i class="fa fa-rss"></i><p>Others</p><input type="checkbox" value="others" [checked]="checked_sm.others" (click)="sm_checkbox_event($event)"></div>
                                </a>
                                <!--                                <a *ngIf="total_per_sm.others != 'denied'" class="">
                                                                    <div class="results_type"><i class="fa fa-linkedin"></i><p>Linkedin</p><input type="checkbox" value="linkedin" [checked]="checked_sm.linkedin" (click)="sm_checkbox_event($event)"></div>
                                                                </a>
                                                                <a *ngIf="total_per_sm.others != 'denied'" class="">
                                                                    <div class="results_type"><i class="fa fa-reddit"></i><p>Reddit</p><input type="checkbox" value="reddit" [checked]="checked_sm.reddit" (click)="sm_checkbox_event($event)"></div>
                                                                </a>-->
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button (click)="close_tag_form()" type="button" class="btn btn-danger">Close</button>
                <button (click)="reset_filter()" type="button" class="btn btn-success">Reset</button>
            </div>
        </div>
    </div>
    <!--</form>-->
</div>
<ngx-spinner bdColor = "rgba(0, 0, 0, 0.8)" size = "medium" color = "rgb(199, 28, 109)" type = "square-loader" [fullScreen] = "true"></ngx-spinner>
<app-footer></app-footer>